import { message } from 'antd';
import { UserModel } from '../models/UserModel';
import ApiResponse from '../netWork/ApiResponse';
import Network from '../netWork/Network';

export interface emailBody {
  email: string,
  password: string, //密码（采用RSA加密与解密(jsencrypt.js)）
}

export interface phoneBody {
  zone: string,
  mobile: string,
  password: string,
}

export interface LoginResponse {
  access_token: string,
  expires_in: number,
  type: string,
}

export interface ApiError {
  message: string;
  code?: string;
}

class AuthService {
  private network = Network;
  /**
   * 用户登录
   */
  async emailLogin(request: emailBody): Promise<{message:string,success:boolean}> {
    try {
      const response = await this.network.post<ApiResponse<LoginResponse>>("/auth/login-email", {
        ...request,
        platform: "web"
      });

      // 如果登录成功，保存token
      if (response.code === 200) {
        localStorage.setItem("token", response.data.access_token);
        return {
          message: response.message,
          success: true
        };
      }
      return {
        message: response.message,
        success: false
      };
    } catch (error: any) {
      return{
        success: false,
        message: error.message
      }
    }
  }

  async phoneLogin(request: phoneBody): Promise<{message:string,success:boolean}> {
    try {
      const response = await this.network.post<ApiResponse<LoginResponse>>("/auth/login", {
        ...request,
        platform: "web"
      });
      if (response.code === 200) {
        localStorage.setItem("token", response.data.access_token);
        return {
          message: response.message,
          success: true
        };
      }
      return {
        message: response.message,
        success: false
      };
    } catch (error: any) {
      return{
        success: false,
        message: error.message
      }
    }
  }

  /**
   * 用户登出
   */
  async logout(): Promise<void> {
    try {
      await this.network.post("/auth/logout");
    } catch (error) {
      console.error('登出失败:', error);
    } finally {
      // 清除本地存储的认证信息
      localStorage.removeItem("token");
      localStorage.removeItem("user");
    }
  }

  /**
   * 获取当前用户信息
   */
  async loadCurrentUser(): Promise<UserModel | null> {
    const token = localStorage.getItem("token");
    if (token) {
      try {
        const response = await this.network.get<ApiResponse<UserModel>>("/user/detail");
        if (response.code === 200) {
          localStorage.setItem("id", response.data.id.toString());
          return response.data;
        }
        return null;
      } catch (error) {
        return null;
      }
    }
    return null;
  }

  /**
   * 检查用户是否已登录
   */
  isLoggedIn(): boolean {
    return !!localStorage.getItem('token');
  }

  /**
   * 获取认证token
   */
  getToken(): string | null {
    return localStorage.getItem('token');
  }

  /**
   * 获取用户id
   */
  getUserId(): number | null {
    return Number(localStorage.getItem('id'));
  }

  /**
   * 刷新token
   */
  async refreshToken(): Promise<boolean> {
    try {
      const response = await this.network.post<{ token: string }>('/auth/refresh');
      if (response.token) {
        localStorage.setItem('token', response.token);
        return true;
      }
      return false;
    } catch (error) {
      console.error('刷新token失败:', error);
      return false;
    }
  }
}

export default new AuthService(); 